import { PlayerProperty, Save, Restore } from '../PlayerProperty';
import IPlayerData from '../../IPlayerData';
import { IPlayerState } from '../../../State/Player/IPlayerState';
import { restoreStringifiedArray } from '../../ParseHelper';
import { FTUXType } from "../Progress/FTUXType";

type PlayerStateKey = 'FTUX';
type PlayerDataKeys = 'FTUX';
export default class FTUX implements PlayerProperty<
    PlayerStateKey,
    PlayerDataKeys
> {
    public isChanged(
        playerStateData: IPlayerState,
        playerEndpointData: IPlayerData
    ): boolean {
        return playerEndpointData.FTUX !== JSON.stringify(playerStateData.FTUX);
    }

    public restore(playerEndpointData: IPlayerData): Restore<PlayerStateKey> {
        return restoreStringifiedArray<FTUXType>(
            playerEndpointData.FTUX,
            []
        );
    }

    public save(playerStateData: IPlayerState): Save<PlayerDataKeys> {
        return {
            FTUX: JSON.stringify(playerStateData.FTUX),
        };
    }
}
